import Vue from "vue";
import Router from "vue-router";
import Index from "./pages/index.vue";
import agreement from "./pages/agreement.vue";
import disclaimer from "./pages/disclaimer.vue";
import privacy from "./pages/privacy.vue";
import terms from "./pages/terms.vue";
import legalInfo from "./pages/legal-info.vue";
import Support from "./pages/support.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Index,
    },
    {
      path: "/agreement",
      name: "agreement",
      component: agreement,
    },
    {
      path: "/disclaimer",
      name: "disclaimer",
      component: disclaimer,
    },
    {
      path: "/privacy",
      name: "privacy",
      component: privacy,
    },
    {
      path: "/terms",
      name: "terms",
      component: terms,
    },
    {
      path: "/legal-info",
      name: "legal-info",
      component: legalInfo,
    },
    {
      path: "/support",
      name: "support",
      component: Support,
    },
  ],
});
